import { IsVisibleOnGridBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnGridBase';
export class IsVisibleOnGridValueConverter extends IsVisibleOnGridBaseValueConverter {

}